@switch (context ? context.type : '') {
    @default {
        <fui-edit-multiselect-input [addable]="showAddOption" (added$)="added$.emit($event)"
                                    [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                                    [optionOpenable]="showOptionOpenOption" (optionOpened$)="optionOpened$.emit($event)"
                                    [control]="control" [disabled]="disabled"
                                    [field]="valueField"
                                    [allowLabelMarkup]="allowLabelMarkup"
                                    [filterable]="internallyFilterable"
                                    (filtered$)="filtered$.emit($event)" #input [key]="labelField"
                                    [summaryKey]="summaryLabelField"
                                    [label]="label" [loading]="loading" [(ngModel)]="value"
                                    [options]="options"
                                    [placeholder]="placeholder" [total]="total" (focussed$)="onFocussed($event)">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-edit-multiselect-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-multiselect-input [addable]="showAddOption" (added$)="added$.emit($event)"
                                      [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                                      [optionOpenable]="showOptionOpenOption"
                                      (optionOpened$)="optionOpened$.emit($event)"
                                      [field]="valueField"
                                      [allowLabelMarkup]="allowLabelMarkup"
                                      [control]="control" [disabled]="disabled"
                                      [filterable]="internallyFilterable"
                                      (filtered$)="filtered$.emit($event)" #input [key]="labelField"
                                      [summaryKey]="summaryLabelField"
                                      [label]="label" [loading]="loading" [(ngModel)]="value"
                                      [options]="options" [placeholder]="placeholder" [total]="total"
                                      (focussed$)="onFocussed($event)">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-filter-multiselect-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-multiselect-input [addable]="showAddOption" (added$)="added$.emit($event)"
                                      [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                                      [optionOpenable]="showOptionOpenOption"
                                      (optionOpened$)="optionOpened$.emit($event)"
                                      [field]="valueField"
                                      [allowLabelMarkup]="allowLabelMarkup"
                                      [control]="control" [disabled]="disabled"
                                      [filterable]="internallyFilterable"
                                      (filtered$)="filtered$.emit($event)" #input [key]="labelField"
                                      [summaryKey]="summaryLabelField"
                                      [label]="label" [loading]="loading" [(ngModel)]="value"
                                      [options]="options" [placeholder]="placeholder" [total]="total"
                                      (focussed$)="onFocussed($event)">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-inline-multiselect-input>
    }
    @case (contextType.PILL) {
        <fui-pill-multiselect-input [addable]="showAddOption" (added$)="added$.emit($event)"
                                    [extendable]="showExtendedSearchOption" (extended$)="extended$.emit($event)"
                                    [optionOpenable]="showOptionOpenOption" (optionOpened$)="optionOpened$.emit($event)"
                                    [field]="valueField"
                                    [allowLabelMarkup]="allowLabelMarkup"
                                    [control]="control" [disabled]="disabled"
                                    [filterable]="internallyFilterable" (filtered$)="filtered$.emit($event)" #input
                                    [key]="labelField" [summaryKey]="summaryLabelField" [label]="label"
                                    [loading]="loading"
                                    [(ngModel)]="value"
                                    [options]="options" [placeholder]="placeholder"
                                    [removable]="pillRemovable" (removed$)="remove()"
                                    [showSelections]="showSelections"
                                    [total]="total" (focussed$)="onFocussed($event)"
                                    [actions]="actions"
                                    (action$)="action$.emit($event)">
            <ng-container ngProjectAs="fui-content-section" *ngTemplateOutlet="content"></ng-container>
        </fui-pill-multiselect-input>
    }
}
<ng-template #content>
    <ng-content select="fui-content-section"></ng-content>
</ng-template>
